import { render, staticRenderFns } from "./ShoppingFilter.vue?vue&type=template&id=6c74e89a&scoped=true&"
import script from "./ShoppingFilter.vue?vue&type=script&lang=js&"
export * from "./ShoppingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74e89a",
  null
  
)

export default component.exports